import React from 'react';
import PropTypes from 'prop-types';

import CategoryStep from './CategoryStep';
import LocationStep from './LocationStep';
import QuestionStep from './QuestionStep';
import StartByStep from './StartByStep';
import DescriptionStep from './DescriptionStep';
import ContactDetailsStep from './ContactStep';
import UserActions from './shared/UserActions';
import { CategoryType } from '../types';
import { isQuestionStep } from '../../../utils/questions';
export const FORM_KEY = 'GQWIZARD';

const getQuestionForStep = (step, questions) =>
  questions.find(q => q.id === Number(step.split(':')[1]));

const getAnswerForStep = (step, answers) => {
  const key = `get_quotes_question_${step.split(':')[1]}`;
  const answer = answers.find(a => a.key === key);
  if (answer && Array.isArray(answer.value)) {
    return !!answer.value.filter(Boolean).length;
  }
  return answer && !!answer.value;
};

export const getCurrentCategory = (selectedCategory, initialCategory) => {
  if (selectedCategory) {
    return selectedCategory.label;
  } else if (initialCategory) {
    return initialCategory.name;
  }
  return 'No Category';
};

export const MultiStepForm = ({
  step,
  questions,
  answers,
  next,
  back,
  close,
  progress,
  categories,
  user,
  change,
  selectedCategory,
  onSelectCategory,
  initialCategory,
  postJob
}) => (
  <React.Fragment>
    <UserActions
      back={back}
      close={close}
      category={getCurrentCategory(selectedCategory, false)}
      step={step}
      progress={progress}
    />
    {step === 'CATEGORIES' && (
      <CategoryStep
        categories={categories}
        onSubmit={next}
        change={change}
        selectedCategory={selectedCategory}
        onSelectCategory={onSelectCategory}
        category={getCurrentCategory(selectedCategory, false)}
      />
    )}
    {step === 'LOCATION' && (
      <LocationStep
        onSubmit={next}
        selectedCategory={selectedCategory}
        category={getCurrentCategory(selectedCategory, false)}
      />
    )}
    {step === 'STARTBY' && (
      <StartByStep
        onSubmit={next}
        selectedCategory={selectedCategory}
        category={getCurrentCategory(selectedCategory, false)}
      />
    )}
    {isQuestionStep(step) && (
      <QuestionStep
        key={step}
        question={getQuestionForStep(step, questions)}
        answered={getAnswerForStep(step, answers)}
        selectedCategory={selectedCategory}
        onSubmit={next}
        category={getCurrentCategory(selectedCategory, false)}
      />
    )}
    {step === 'DESCRIPTION' && (
      <DescriptionStep
        onSubmit={next}
        selectedCategory={selectedCategory}
        category={getCurrentCategory(selectedCategory, false)}
      />
    )}
    {step === 'CONTACT' && (
      <ContactDetailsStep
        user={user}
        onSubmit={postJob}
        initialCategory={initialCategory}
        selectedCategory={selectedCategory}
        category={getCurrentCategory(selectedCategory, false)}
      />
    )}
  </React.Fragment>
);

export default MultiStepForm;

MultiStepForm.propTypes = {
  step: PropTypes.string,
  questions: PropTypes.array,
  answers: PropTypes.array,
  next: PropTypes.func,
  back: PropTypes.func,
  close: PropTypes.func,
  progress: PropTypes.string,
  categories: PropTypes.array,
  user: PropTypes.object,
  change: PropTypes.func,
  initialCategory: CategoryType,
  selectedCategory: PropTypes.object,
  onSelectCategory: PropTypes.func,
  postJob: PropTypes.func
};
